import { inject, observer } from 'mobx-react'

import { AdviceDataTable } from '../../../../components'
import { StepContent } from '../../elements'
import { getHeadingSegments } from './headingMessage'
import { buildColumns, buildRows, includedGoalsTotal } from './tableData'
import { Heading, TableWrap } from './style'

// Renders the heading segments, showing the total in bold.
function HeadingText({ segments }) {
  return segments.map((segment, index) =>
    segment.bold ? <strong key={index}>{segment.text}</strong> : segment.text
  )
}

/**
 * Goals step of the step-by-step advice flow. Like the SSI step it makes no
 * recommendation — it reflects the goals the user has told us about: a heading
 * with the total still needed across included goals, and a table of each
 * current (non-past) goal's date, amount needed, and whether it's included.
 *
 * The step is only reachable when at least one current goal is included; Advice
 * guards the route and skips traversal otherwise (see hasIncludedGoals).
 */
const Goals = ({ store }) => {
  const goals = store.currentGoals
  const activeCase = store.modifiedCase || store.recommendedCase

  // The shell shows the loader and the route guard redirects when there are no
  // included goals; this just guards a transient render before data resolves.
  if (!activeCase) {
    return null
  }

  const includedIds = activeCase.includedGoalsIds
  const includedCount = goals.filter(goal => includedIds.includes(goal.id)).length
  if (includedCount === 0) {
    return null
  }

  const headingSegments = getHeadingSegments({
    includedCount,
    total: includedGoalsTotal({ goals, includedIds }),
  })

  const columns = buildColumns()
  const rows = buildRows({ goals, includedIds })

  return (
    <StepContent>
      <Heading>
        <HeadingText segments={headingSegments} />
      </Heading>

      <TableWrap>
        <AdviceDataTable columns={columns} rows={rows} />
      </TableWrap>
    </StepContent>
  )
}

export default inject('store')(observer(Goals))
